import { Map } from 'immutable';
import { createAction, handleActions } from 'redux-actions';
export const actions = {
    SHOW_DOCUMENT: createAction('GLOBAL/RESPONSIVE/SHOW_DOCUMENT'),
    HIDE_DOCUMENT: createAction('GLOBAL/RESPONSIVE/HIDE_DOCUMENT'),
    SET_BOARD_COLUMN: createAction('GLOBAL/RESPONSIVE/SET_BOARD_COLUMN'),
    MOBILE_VIEW: createAction('GLOBAL/RESPONSIVE/MOBILE_VIEW'),
    NOT_MOBILE_VIEW: createAction('GLOBAL/RESPONSIVE/NOT_MOBILE_VIEW'),
};
export const initialState = Map({
    documentVisible: false,
    boardActiveColumn: 0,
    isMobileView: null,
});
const reducer = handleActions({
    [actions.SHOW_DOCUMENT]: (state) => state.set('documentVisible', true),
    [actions.HIDE_DOCUMENT]: (state) => state.set('documentVisible', false),
    [actions.SET_BOARD_COLUMN]: (state, action) => {
        return state.set('boardActiveColumn', action.payload);
    },
    [actions.MOBILE_VIEW]: (state) => {
        return state.set('isMobileView', true);
    },
    [actions.NOT_MOBILE_VIEW]: (state) => {
        return state.set('isMobileView', false);
    },
}, initialState);
export default reducer;
